import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/global-config';

import { OfflineView } from 'src/sections/error';

function OfflinePage() {
  return (
    <>
      <Helmet>
        <title>Offline | {CONFIG.appName}</title>
      </Helmet>
      <OfflineView />
    </>
  );
}

export default OfflinePage;
